import { render, staticRenderFns } from "./helpWrap.vue?vue&type=template&id=da9a1e20&"
import script from "./helpWrap.vue?vue&type=script&lang=js&"
export * from "./helpWrap.vue?vue&type=script&lang=js&"
import style0 from "./helpWrap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports